var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('v-img',{attrs:{"src":require("@/assets/logo.png"),"contain":"","height":"80%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }